const imagePathsVip: string[] = [];

const requireImages = (count: number) => {
  for (let i = 1; i <= count; i++) {
    import(`./vip${i}.png`)
      .then((module) => {
        imagePathsVip.push(module.default);
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

requireImages(50);

export { default as IconVip1 } from "./vip1.png";
export { default as IconVip2 } from "./vip2.png";
export { default as IconVip3 } from "./vip3.png";
export { default as IconVip4 } from "./vip4.png";
export { default as IconVip5 } from "./vip5.png";
export { default as IconVip6 } from "./vip6.png";
export { default as IconVip7 } from "./vip7.png";
export { default as IconVip8 } from "./vip8.png";
export { default as IconVip9 } from "./vip9.png";
export { default as IconVip10 } from "./vip10.png";
export { default as IconVip11 } from "./vip11.png";
export { default as IconVip12 } from "./vip12.png";
export { default as IconVip13 } from "./vip13.png";
export { default as IconVip14 } from "./vip14.png";
export { default as IconVip15 } from "./vip15.png";
export { default as IconVip16 } from "./vip16.png";
export { default as IconVip17 } from "./vip17.png";
export { default as IconVip18 } from "./vip18.png";
export { default as IconVip19 } from "./vip19.png";
export { default as IconVip20 } from "./vip20.png";
export { default as IconVip21 } from "./vip21.png";
export { default as IconVip22 } from "./vip22.png";
export { default as IconVip23 } from "./vip23.png";
export { default as IconVip24 } from "./vip24.png";
export { default as IconVip25 } from "./vip25.png";
export { default as IconVip26 } from "./vip26.png";
export { default as IconVip27 } from "./vip27.png";
export { default as IconVip28 } from "./vip28.png";
export { default as IconVip29 } from "./vip29.png";
export { default as IconVip30 } from "./vip30.png";
export { default as IconVip31 } from "./vip31.png";
export { default as IconVip32 } from "./vip32.png";
export { default as IconVip33 } from "./vip33.png";
export { default as IconVip34 } from "./vip34.png";
export { default as IconVip35 } from "./vip35.png";
export { default as IconVip36 } from "./vip36.png";
export { default as IconVip37 } from "./vip37.png";
export { default as IconVip38 } from "./vip38.png";
export { default as IconVip39 } from "./vip39.png";
export { default as IconVip40 } from "./vip40.png";
export { default as IconVip41 } from "./vip41.png";
export { default as IconVip42 } from "./vip42.png";
export { default as IconVip43 } from "./vip43.png";
export { default as IconVip44 } from "./vip44.png";
export { default as IconVip45 } from "./vip45.png";
export { default as IconVip46 } from "./vip46.png";
export { default as IconVip47 } from "./vip47.png";
export { default as IconVip48 } from "./vip48.png";
export { default as IconVip49 } from "./vip49.png";
export { default as IconVip50 } from "./vip50.png";
